import React from 'react'
import axios from 'axios'
// import { useState, useEffect } from 'react'
const SERVER_URL = process.env.REACT_APP_SERVER_URL


const EditProductModal = ({ categories, emodal, setEmodal, efData, setEfdata }) => {

    const alert = (msg, type) => (
        <div className={`bg-${type} my-2 py-2 px-4 w-100`}>{msg}</div>
    );

    if (efData.error || efData.success) {
        setTimeout(() => {
            setEfdata({ ...efData, success: false, error: false });
        }, 2000);
    }


    const formSubmitHandler = (e) => {
        e.preventDefault();
        console.log(efData);
        let formData = new FormData();
        if (efData.pEditImages) {
            for (const file of efData.pEditImages) {
                formData.append("pEditImages", file);
            }
        }
        // console.log(formData);
        /* Most important part for uploading multiple image  */
        formData.append("pId", efData.pId);
        formData.append("pName", efData.pName);
        formData.append("pDescription", efData.pDescription);
        formData.append("pStatus", efData.pStatus);
        formData.append("pCategory", efData.pCategory._id);
        formData.append("pType", efData.pType);
        formData.append("pQuantity", efData.pQuantity);
        formData.append("pPrice", efData.pPrice);
        formData.append("pOffer", efData.pOffer);
        formData.append("pImages", efData.pImages);

        if (localStorage.getItem("userTokenTime") != null) {
            axios
                .post(
                    SERVER_URL + "/api/admin/edit-product",
                    formData,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization:
                                "Bearer " +
                                JSON.parse(localStorage.getItem("userTokenTime")).token,
                        },
                    }
                )
                .then((res) => {
                    console.log(res.data);
                    if (res.data.error) {
                        setEfdata({ ...efData, success: false, error: res.data.error });
                    }
                    else {
                        setEfdata({
                            pId: "",
                            pName: "",
                            pDescription: "",
                            pImages: [],
                            pEditImages: [],
                            pStatus: "",
                            pType: "",
                            pCategory: "",
                            pQuantity: "",
                            pPrice: "",
                            pOffer: "",
                            error: false,
                            success: false,
                        });
                        setEmodal(false);
                    }
                }).catch((e) => {
                    console.log(e);
                });
        }
    };
    return (
        <React.Fragment>
            <div className={`${emodal ? "" : "ehidden"} backdrop`}></div>
            <div
                className={`${emodal ? "" : "ehidden"} addmodel cmodel`}
            >
                <div className="modaldiv relative space-y-4 overflow-y-auto px-4 py-2 md:px-8">
                    <div className="modal__header">
                        <span className="modal__heading">
                            Edit Product
                        </span>
                        {/* Close Modal */}
                        <span
                            style={{ background: "#303031" }}
                            onClick={() => setEmodal(false)}
                            className="modal-close-btn"
                        >
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
                        </span>
                    </div>
                    {efData.error ? alert(efData.error, "red") : ""}
                    {efData.success ? alert(efData.success, "green") : ""}
                    <form className="w-100" >
                        <div className="d-flex">

                            <div className="edit__form__input w-50">
                                <label htmlFor="name">Product Name</label>
                                <input
                                    onChange={(e) =>
                                        setEfdata({
                                            ...efData,
                                            success: false,
                                            error: false,
                                            pName: e.target.value,
                                        })
                                    }
                                    value={efData.pName}
                                    className="w-100 px-4 py-2 border focus:outline-none"
                                    type="text"
                                />
                            </div>
                            <div className="edit__form__input w-50 ml-2">
                                <label htmlFor="price">Product Price *</label>
                                <input
                                    value={efData.pPrice}
                                    onChange={(e) =>
                                        setEfdata({
                                            ...efData,
                                            error: false,
                                            success: false,
                                            pPrice: e.target.value,
                                        })
                                    }
                                    type="number"
                                    className="w-100 px-4 py-2 border focus:outline-none"
                                    id="price"
                                />
                            </div>

                        </div>
                        <div className="edit__form__input">
                            <label htmlFor="description">Product Description</label>
                            <textarea
                                onChange={(e) =>
                                    setEfdata({
                                        ...efData,
                                        success: false,
                                        error: false,
                                        pDescription: e.target.value,
                                    })
                                }
                                value={efData.pDescription}
                                className="px-4 py-2 border focus:outline-none"
                                name="description"
                                id="description"
                                cols={5}
                                rows={2}
                            />
                        </div>

                        {/* Image Field & function */}
                        <div className="edit__form__input">
                            <label htmlFor="image">Product Images *</label>
                            {efData.pImages ? (
                                <div className="flex space-x-1">
                                    <img
                                        className="h-16 w-16 object-cover"
                                        style={{ height: "4rem", width: "4rem" }}
                                        src={`/uploads/products/${efData.pImages[0]}`}
                                        alt="productImage"
                                    />
                                </div>
                            ) : (
                                ""
                            )}
                            {/* <span className="text-gray-600 text-xs">Must need 2 images</span> */}
                            <input
                                onChange={(e) =>
                                    setEfdata({
                                        ...efData,
                                        error: false,
                                        success: false,
                                        pEditImages: [...e.target.files],
                                    })
                                }
                                type="file"
                                accept=".jpg, .jpeg, .png"
                                className="px-4 py-2 border focus:outline-none"
                                id="image"
                                multiple
                            />
                        </div>
                        <div className="d-flex">
                        <div className="edit__form__input">
                                <label htmlFor="status">Product Type</label>
                                <select
                                    name="status"
                                    value={efData.pType}
                                    onChange={(e) =>
                                        setEfdata({
                                            ...efData,
                                            success: false,
                                            error: false,
                                            pType: e.target.value,
                                        })
                                    }
                                    className="px-4 py-2 border focus:outline-none"
                                    id="type"
                                >
                                    <option disabled value="">
                                        Select a type
                                    </option>
                                    <option name="type" value="Men">
                                        Men
                                    </option>
                                    <option name="type" value="Women">
                                        Women
                                    </option>
                                    <option name="type" value="Kids">
                                        Kids
                                    </option>
                                </select>
                            </div>
                            <div className="edit__form__input ml-2">
                                <label htmlFor="status">Product Category *</label>
                                <select
                                    value={efData.pCategory}
                                    onChange={(e) =>
                                        setEfdata({
                                            ...efData,
                                            error: false,
                                            success: false,
                                            pCategory: e.target.value,
                                        })
                                    }
                                    name="status"
                                    className="px-4 py-2 border focus:outline-none"
                                    id="status"
                                >
                                    <option disabled value="">
                                        Select a category
                                    </option>
                                    {categories.length > 0
                                        ? categories.filter(category => category.cType === efData.pType).map(function (elem) {
                                            return (
                                                <option name="status" value={elem._id} key={elem._id}>
                                                    {elem.cName}
                                                </option>
                                            );
                                        })
                                        : ""}
                                </select>
                            </div>
                            
                        </div>
                        <div className='d-flex'>
                            <div className="edit__form__input" style={{ width: "33.33333%" }}>
                                <label htmlFor="status">Product Status</label>
                                <select
                                    name="status"
                                    onChange={(e) =>
                                        setEfdata({
                                            ...efData,
                                            success: false,
                                            error: false,
                                            pStatus: e.target.value,
                                        })
                                    }
                                    className="px-4 py-2 border focus:outline-none"
                                    id="status"
                                >
                                    <option name="status" value="Active">
                                        Active
                                    </option>
                                    <option name="status" value="Disabled">
                                        Disabled
                                    </option>
                                </select>
                            </div>
                            <div className="edit__form__input ml-2" style={{ width: "33.33333%" }}>
                                <label htmlFor="quantity">Product in Stock *</label>
                                <input
                                    value={efData.pQuantity}
                                    onChange={(e) =>
                                        setEfdata({
                                            ...efData,
                                            error: false,
                                            success: false,
                                            pQuantity: e.target.value,
                                        })
                                    }
                                    type="number"
                                    className="w-100 px-4 py-2 border focus:outline-none"
                                    id="quantity"
                                />
                            </div>
                            <div className="edit__form__input ml-2" style={{ width: "33.33333%" }}>
                                <label htmlFor="offer">Product Offfer (%) *</label>
                                <input
                                    value={efData.pOffer}
                                    onChange={(e) =>
                                        setEfdata({
                                            ...efData,
                                            error: false,
                                            success: false,
                                            pOffer: e.target.value,
                                        })
                                    }
                                    type="number"
                                    className="w-100 px-4 py-2 border focus:outline-none"
                                    id="offer"
                                />
                            </div>
                        </div>

                        <div className="create-btn-div">
                            <button
                                style={{ background: "#303031" }}
                                type="submit"
                                className="create__btn"
                                onClick={formSubmitHandler}
                            >
                                Update Product
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </React.Fragment>
    )
}

export default EditProductModal